/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { MasonryAccordionItemRenderer } from '@leagueplatform/masonry-renderers';

export const MasonryAccordionItemRendererOverride: typeof MasonryAccordionItemRenderer =
  (props) => (
    <MasonryAccordionItemRenderer
      css={{
        '.GDS-accordion-button': { paddingBlock: '$one' },
        '.GDS-accordion-content': { paddingBlockEnd: '$one' },
      }}
      {...props}
    />
  );
